// extracted by mini-css-extract-plugin
export default {"main-image":"main-image__doP6w","main-image-img":"main-image-img__cPaTL"};